export const setFormStep = (payload: number) => ({
  type: 'SET_FORM_STEP',
  payload,
});